/**
 * @generated SignedSource<<252c302933f37131059e2ae835a2a56a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTodoEditResponseImageGenerateUploadLinkMutation$variables = Record<PropertyKey, never>;
export type useTodoEditResponseImageGenerateUploadLinkMutation$data = {
  readonly uploadImageLink: {
    readonly image: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
    };
    readonly url: string;
  } | null;
};
export type useTodoEditResponseImageGenerateUploadLinkMutation = {
  response: useTodoEditResponseImageGenerateUploadLinkMutation$data;
  variables: useTodoEditResponseImageGenerateUploadLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTodoEditResponseImageGenerateUploadLinkMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UploadImageLinkResponse",
        "kind": "LinkedField",
        "name": "uploadImageLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Image_image"
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useTodoEditResponseImageGenerateUploadLinkMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UploadImageLinkResponse",
        "kind": "LinkedField",
        "name": "uploadImageLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbhash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "sizes",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlExpiresAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "173ad7eb0504ebe25f4d8304b4363394",
    "id": null,
    "metadata": {},
    "name": "useTodoEditResponseImageGenerateUploadLinkMutation",
    "operationKind": "mutation",
    "text": "mutation useTodoEditResponseImageGenerateUploadLinkMutation {\n  uploadImageLink {\n    image {\n      id\n      ...Image_image\n    }\n    url\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n"
  }
};
})();

(node as any).hash = "890bd026924782a7bfc34414f23883d8";

export default node;
